import {
  call, takeLatest,
} from 'redux-saga/effects';
import { CONFIG } from '~/_shared/constants/config';
import { select } from '~/_shared/utils/saga/effects';
import { notNullOrUndefined } from '~/_shared/utils/typeGuards';
import { createBoundaryTerritoryGroupRequestParams } from '~/sidebar/sidebarApps/mapTools/boundary/boundaryTerritoryGroup.helpers';
import { SAMPLE_AGS_DEMOS } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import { appStore } from '~/store/app.store';
import { BoundaryTerritoryType } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroup.type';
import { createOfflineBoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.sagas';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import { dataLayersToolBoundaryTerritoryGroupsCreated } from '~/store/frontendState/mapTools/dataLayers/dataLayers.actionCreators';
import { MAP_SETTINGS_FETCH_DATA_SUCCESS } from '~/store/mapSettings/data/mapSettingsData.actionTypes';
import { waitForMapSettingsReady } from '~/store/mapSettings/ready/mapSettingsReady.sagas.helpers';
import { clientIdSelector } from '~/store/selectors/useClientIdSelector';
import { mapIdSelector } from '~/store/selectors/useMapIdSelector';

export function* mapSettingsDataLayersSaga() {
  if (CONFIG.ENABLE_DATA_LAYERS) {
    yield takeLatest(MAP_SETTINGS_FETCH_DATA_SUCCESS, onMapSettingsFetchDataSuccess);
  }
}

export function* onMapSettingsFetchDataSuccess() {
  yield call(waitForMapSettingsReady);
  yield call(createDataLayersArtificialBoundaryTerritoryGroups);
}

function* createDataLayersArtificialBoundaryTerritoryGroups() {
  const clientId: ReturnType<typeof clientIdSelector> = yield select(clientIdSelector);
  const mapId: ReturnType<typeof mapIdSelector> = yield select(mapIdSelector);
  const demographicsToLoad = SAMPLE_AGS_DEMOS;

  if (!mapId || !clientId) {
    return;
  }

  const numberOfRanges = 5;

  const requests = demographicsToLoad.map(({ boundaryGroupId, demographicId }) => createBoundaryTerritoryGroupRequestParams({
    mapId,
    boundaryGroupId,
    territoryType: BoundaryTerritoryType.Demographic,
    demographicId,
    numberOfRanges,
  }));

  const newBoundaryTerritoryGroups: ReadonlyArray<BoundaryTerritoryGroup> = yield call(
    createOfflineBoundaryTerritoryGroup,
    requests,
    clientId,
  );

  if (newBoundaryTerritoryGroups) {
    const finalBTGs = demographicsToLoad.map(({ boundaryGroupId, demographicId }) => {
      return newBoundaryTerritoryGroups.find(btg => btg.boundaryGroupId === boundaryGroupId && btg.settings.demographicId === demographicId);
    }).filter(notNullOrUndefined);

    appStore.dispatch(dataLayersToolBoundaryTerritoryGroupsCreated(finalBTGs));
    // console.log('final artificial BTGs', finalBTGs);
  }
}
